import { useEffect } from 'react';
import { getText } from '@storebrand-digital/fms-translations';

import { useFormik } from 'formik';
import { filterActions } from './reducer';
import { useProducts } from './hooks';
import { useAppDispatch, useAppSelector } from '../../app/store';
import { selectFilters } from './selectors';
import DropdownFilter from '../../components/DropdownFilter';
import React from 'react';

function FilterFormProducts() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFilters);
  const { data: products, status } = useProducts();
  const formik = useFormik({
    initialValues: {
      products: filters.products ?? [],
    },
    enableReinitialize: true,
    onSubmit: () => {},
  });

  useEffect(() => {
    const selectedProducts = formik.values.products ?? [];
    dispatch(filterActions.changeProducts(selectedProducts));
  }, [formik.values.products, dispatch]);

  const handleSelectionChange = (selectedValues: (string | number)[]) => {
    formik.setFieldValue('products', selectedValues);
  };

  const handleClear = () => {
    formik.setFieldValue('products', []);
  };

  const transformProductsToOptions = () => {
    return (
      products?.map((product) => ({
        label: product.startsWith('sharedProductNames.')
          ? getText(product) || '(blank)'
          : product,
        value: product,
      })) ?? []
    );
  };

  const isLoading = status === 'pending';
  const hasError = status === 'error';
  const filterTitle = getText('filter.product.title');
  const headerTitle = getText('filter.product.heading');

  return (
    <DropdownFilter
      name="products"
      heading={headerTitle}
      title={filterTitle}
      options={transformProductsToOptions()}
      selectedValues={formik.values.products}
      onSelectionChange={handleSelectionChange}
      onClear={handleClear}
      loading={isLoading}
      error={hasError ? getText('filter.product.fetchError') : undefined}
      trackId="button-dropdownfilter_product|Vis produkt"
    />
  );
}

export default FilterFormProducts;
